<template>
    <van-popup class="canvasSignature" v-model="show" closeable round @close="onHidePopup">
        <div class="title">请于下方框内签字（正楷）</div>
        <canvas ref="canvas" class="signature" @touchstart="start" @touchmove="move"></canvas>
        <div class="btn">
            <button @click="clearCanvas">重新签字</button>
            <button @click="saveSignature">签字完毕</button>
        </div>
    </van-popup>
  </template>
  
  <script>
  import Vue from "vue";
  import { Popup, Button } from 'vant';
  Vue.use(Popup);
  Vue.use(Button);
  
  export default {
    props: {
        show: {
          type: Boolean,
          default: false,
        }
    },
    data() {
      return {
        context: null,
        canvas: null
      };
    },
    components: {

    },
    mounted() {
        this.canvas = this.$refs.canvas;
        this.context = this.$refs.canvas.getContext('2d');
        this.canvas.width = this.canvas.offsetWidth;
        this.canvas.height = this.canvas.offsetHeight;
    },
    methods: {
    start(e) {
      e.preventDefault();
      this.context.beginPath();
      this.context.moveTo(this.getPoint(e)[0], this.getPoint(e)[1]);
    },
    move(e) {
      e.preventDefault();
      this.context.lineTo(this.getPoint(e)[0], this.getPoint(e)[1]);
      this.context.stroke()
    },
    getPoint(event) {
        var touches = event.touches[0];
        var rect = this.$refs.canvas.getBoundingClientRect();
        var x = touches.clientX - rect.left;
        var y = touches.clientY - rect.top;
        return [x, y];
    },
    clearCanvas() {
      this.context.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
    },
    saveSignature() {
      const avatarUrl = this.$refs.canvas.toDataURL();
      // 你可以将dataUrl发送到服务器，或者在客户端进行处理
      console.log(avatarUrl);
      this.$emit("confirm", avatarUrl)
    },
    onHidePopup() {
      this.$emit("close", {});
    },
  },

    
  };
  </script>
  
  <style>
    .canvasSignature{
      overflow: hidden;
    }
    .canvasSignature .title{
        text-align: center;
        color: #838383;
        padding: 10px 0;
    }
    .signature{
        width: 100%;
        /* height: 200px; */
        background-color: #F8F8F8;
    }
    .canvasSignature .btn {
        width: 340px;
        height: 50px;
        text-align: right;
        margin: 13px;
    }
    .canvasSignature .btn button:first-child {
        color: #fff;
        background-color: #9C26B0;
    }
    .canvasSignature .btn button:last-child {
        color: white;
        background-color: #0081FF;
    }
    .canvasSignature .btn button {
        width: 140px;
        height: 35px;
        display: inline-block;
        line-height: 35px;
        border-radius: 8px;
        /* box-shadow: 0px 0px 1px 1px #c5c5c5; */
        margin: 15px;
    }
    canvas {
        background-color: white;
    }
  </style>
  